import Link from "next/link";
import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { ArrowRight } from "lucide-react";
import { PRIMARY_CTA_HREF, PRIMARY_CTA_LABEL, SECONDARY_CTA_HREF, SECONDARY_CTA_LABEL } from "./homeContent";

export function HomeFinalCta() {
  return (
    <Box as="section" py={{ base: 16, md: 20 }} bg="orange.900">
      <Container maxW="container.xl">
        <VStack spacing={6} textAlign="center">
          <Heading as="h2" size={{ base: "xl", md: "2xl" }} color="black">
            Pronto para organizar sua barbearia?
          </Heading>
          <Text fontSize={{ base: "md", md: "lg" }} maxW="2xl" color="blackAlpha.800">
            Comece agora, teste grátis por 7 dias e conheça o Meu Barbeiro PRO na
            prática.
          </Text>
          <HStack spacing={4} flexWrap="wrap" justify="center">
            <Button
              as={Link}
              href={PRIMARY_CTA_HREF}
              size="lg"
              bg="black"
              color="white"
              rightIcon={<ArrowRight size={16} />}
              _hover={{ opacity: 0.85 }}
            >
              {PRIMARY_CTA_LABEL}
            </Button>
            <Button
              as={Link}
              href={SECONDARY_CTA_HREF}
              size="lg"
              variant="outline"
              borderColor="black"
              color="black"
              _hover={{ bg: "blackAlpha.100" }}
            >
              {SECONDARY_CTA_LABEL}
            </Button>
          </HStack>
        </VStack>
      </Container>
    </Box>
  );
}
